export default __webpack_public_path__ + "static/media/MTcarpaFull_LateralIzq.97f43daa.webp";